"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var viewerCor = exports.viewerCor = function viewerCor() {

  var viewCenter = map.getCenter();
  var lat = viewCenter.lat,
      lng = viewCenter.lng;
  if (17.84 > lat || lat > 26.65 || lng < 109.01 || lng > 117.81) map.setView([23, 113], 5, {});
};


//////////////////
// WEBPACK FOOTER
// ./js/business/viewer.js
// module id = 30
// module chunks = 0